export const toggleLeftPaneAriaLabel = "qOb";
export default {toggleLeftPaneAriaLabel};